import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { savedRecipes } from '__mocks__/mockData/recipes-data';

const RecipesApi = [
  rest.get(`${API_ROOT}saved-recipes`, (req, res, ctx) => res(ctx.json(savedRecipes))),
  rest.delete(`${API_ROOT}saved-recipes${savedRecipes[0].id}`, (req, res, ctx) => res(ctx.json(savedRecipes[0]))),
  rest.post(`${API_ROOT}saved-recipes`, (req, res, ctx) => res(ctx.json(savedRecipes[0]))),
];
export default RecipesApi;
